const svgDir = require.context('!@svgr/webpack!/public/images/icons', true, /\.svg$/)

/**
 * This is a JavaScript function that renders an SVG icon based on the provided category and name.
 * @returns an SVG icon component.
 */

export default function Icon({ category, name, className, style = {}, ...props }) {
    try {
        const Icon = svgDir(category ? `./${category}/${name}.svg` : `./${name}.svg`).default

        if (!Icon) return console.error(`Icon ${name} not found`)

        return <Icon className={className} style={style} {...props} />
    } catch (email) {
        console.error(`Icon ${name} not found`)
    }
    return null
}
